import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "duiZhuang";

store.registerModule(moduleName, {
  namespaced: true,
  state: {},
  actions: {
    // 获取境外车type=1、国内车2
    async getWeighingCarInfo({ commit }, payload) {
      var result = await api.get(
        `/api/WeighingCarInfo/GetDock?type=${payload}`
      );
      return result.data;
    },

    // 获得对装汇总报表
    async getDockSummaryReport({ commit }, payload) {
      var result = await api.get(
        `/api/WeighingDockReport/DockSummary?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    // 获得对装明细报表
    async getDockDetailReport({ commit }, payload) {
      var result = await api.get(
        `/api/WeighingDockReport/DockDetail?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    // 获得对装明细订单报表
    async getDockNOReport({ commit }, payload) {
      var result = await api.get(
        `/api/WeighingDockReport/WeighingDockDetail?NumericalOrder=${payload}`
      );
      return result.data;
    },
  },
});

export default moduleName;
